import React from 'react';
import styles from './ChangePlanHeader.module.scss';
interface Props {
  Headingtext: string;
}

const ChangePlanHeader = ({ Headingtext }: Props) => {
  return (
    <h1 className={'title  u-marginTz u-marginBz ' + styles.Heading_h1}>
      {Headingtext}
    </h1>
  );
};
export default ChangePlanHeader;
